exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-item[data-v-3428d647]{font-size:.8rem}", ""]);

// exports
